import { Navigate, Routes, Route, BrowserRouter } from 'react-router-dom'; // Remplacer Router par BrowserRouter
import { Suspense, lazy, useEffect, useState } from 'react';

const HomePage = lazy(() => import('./Home'));
const TesteurForm = lazy(() => import('./pages/TesteurForm'));
const InscriptionPharmacie = lazy(() => import('./pages/InscriptionPharmacie'));
const InscriptionSyndicat = lazy(() => import('./pages/InscriptionSyndicat'));
const GardesPage = lazy(() => import('./pages/GardesPage'));
const Confidentialite = lazy(() => import('./pages/Confidentialite'));
const Telecharger = lazy(() => import('./pages/Telecharger'));
const StagesPage = lazy(() => import('./pages/StagesPage'));
const DisponibiliteMedicamentPage = lazy(() => import('./pages/DisponibiliteMedicamentPage'));

const logo =  import('./assets/logo/logo-horizontale.svg'); 

// Loading Component
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-gray-600 font-medium">Chargement...</p>
    </div>
  </div>
);

// const LoadingSpinner = () => (
//   <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50">
//     <div className="text-center">
//       {/* Animation du logo en spinning */}
//       <div className="mb-4">
//         <img 
//           src={logo} 
//           alt="Logo" 
//           className="mx-auto animate-spin-slow"
//         />
//       </div>

//       {/* Animation du spinner circulaire */}
//       <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      
//       {/* Texte de chargement */}
//       <p className="text-gray-600 font-medium text-xl">
//         Chargement, veuillez patienter...
//       </p>
//     </div>
//   </div>
// );

function App() {

    const [isLoading, setIsLoading] = useState(true);

  // Simuler un délai de 2 secondes avant de charger le contenu
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  
  return (
    // Utilise BrowserRouter au lieu de Router
    <BrowserRouter>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/testeurs/android/form" element={<TesteurForm type="android" />} />
          <Route path="/testeurs/ios/form" element={<TesteurForm type="ios" />} />
          <Route path="/testeurs/syndicat/form" element={<TesteurForm type="syndicat" />} />
          <Route path="/testeurs/pharmaciens/form" element={<TesteurForm type="pharmaciens" />} />
          <Route path="/inscription-pharmacie" element={<InscriptionPharmacie />} />
          <Route path="/inscription-syndicat" element={<InscriptionSyndicat />} />
          <Route path="/garde" element={<GardesPage />} />
          <Route path="/garde/:zone" element={<GardesPage />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/stages" element={<StagesPage />} />
          <Route path="/disponibilite-medicament" element={<DisponibiliteMedicamentPage />} />
          <Route path="/app" element={<Telecharger />} />
          <Route path="*" element={<Navigate to="/" replace />} />    
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
